import { createSvgComponent } from "../../icon/createSvgComponent";
import WarningFill from "@core/__generated__/icon/figma/warning-fill.svg";
export default createSvgComponent(WarningFill);